import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { db } from "../../firebase"; // Ajusta la ruta si estás en otro nivel

import { collection, doc, onSnapshot, query, where } from "firebase/firestore";
import { useRef } from 'react';
import InvoiceScanner from './InvoiceScanner.jsx';
import { uploadImage } from '../../lib/cloudinaryApi';
import { createIncomingEntryApi, updateIncomingEntryApi, createIncomingOperationKey } from '../../lib/incomingApi';

const localYMD = () =>
  new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 10);

const IncomingForm = ({
  currentUser,
  products,
  editingEntry,
  setEditingEntry,
  setShowForm,
  setIncomingItems,
  setProducts
}) => {
const [entryData, setEntryData] = useState({
  invoiceNumber: '',
  supplier: '',
  entryType: 'compra',
  paymentStatus: 'pendiente',
  proofImage: '',
  proofImageId: '', // 👈 nuevo campo
  products: [],
registeredBy:
  typeof currentUser === 'string'
   ? currentUser
   : (currentUser?.username || currentUser?.email || currentUser?.uid || ''),
  registrationDate: localYMD()
});
  const [editingProductId, setEditingProductId] = useState(null);
const [currentProductInput, setCurrentProductInput] = useState({
  productId: '',
  productName: '',
  barcode: '',
  quantity: 1,
  unitCost: '',  // <- CAMBIO CLAVE: antes era 0, ahora es cadena vacía
  totalCost: 0,
  productUnit: 'unidad',
  createNew: false
});
  const [loading, setLoading] = useState(false);
  const [productSuggestions, setProductSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [proveedores, setProveedores] = useState([]);
  const [mostrarModalNuevoProveedor, setMostrarModalNuevoProveedor] = useState(false);
  const [nuevoProveedor, setNuevoProveedor] = useState("");
const [costMode, setCostMode] = useState('unit'); // 'unit' | 'total'
const [totalCost, setTotalCost] = useState('');
const [mostrarTodos, setMostrarTodos] = useState(false);
const [invoiceFiles, setInvoiceFiles] = useState([]);
const typingTimer = useRef(null);
const saveOperationKeyRef = useRef('');

const normalizedType = (p) => String(p?.type || 'final').toLowerCase();

const formatCurrency = (value) => Math.round(Number(value) || 0).toLocaleString("es-CO");

const normalizeCOP = (value) => {
  if (value === '' || value === null || value === undefined) return 0;
  // Preserve real decimals produced by calculations. Running a numeric value
  // such as 22.2222 through the text parser would turn it into 222222.
  if (typeof value === 'number') {
    return Number.isFinite(value) ? Math.max(0, value) : 0;
  }
  const cleaned = String(value)
    .replace(/[^\d,.-]/g, '')
    .replace(/\./g, '')
    .replace(/,/g, '.');
  const num = Number(cleaned);
  if (!Number.isFinite(num)) return 0;
  return Math.max(0, Math.round(num));
};

const normalizeQuantityNumber = (value) => {
  if (value === '' || value === null || value === undefined) return 0;
  const cleaned = String(value).replace(/,/g, '.').replace(/[^\d.-]/g, '');
  const num = Number(cleaned);
  return Number.isFinite(num) ? num : 0;
};

const normalizeProductName = (value = '') => String(value)
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, ' ')
  .trim();

const safeRegisteredBy = () => typeof currentUser === 'string'
  ? currentUser
  : (currentUser?.username || currentUser?.email || currentUser?.uid || '');

// Firestore no acepta valores `undefined`, ni siquiera dentro de arrays/objetos.
// Algunas entradas antiguas no tienen campos recientes (productUnit/createNew),
// por eso al editar un producto esos campos podían terminar como undefined.
const stripUndefinedDeep = (value) => {
  if (Array.isArray(value)) {
    return value.map(stripUndefinedDeep);
  }

  if (value && typeof value === 'object') {
    const proto = Object.getPrototypeOf(value);
    // No tocar Timestamp, FieldValue/serverTimestamp u otras clases de Firestore.
    if (proto !== Object.prototype && proto !== null) return value;

    return Object.fromEntries(
      Object.entries(value)
        .filter(([, item]) => item !== undefined)
        .map(([key, item]) => [key, stripUndefinedDeep(item)])
    );
  }

  return value;
};

const handleInvoiceApply = ({ supplier, invoiceNumber, date, rows, files }) => {
  const importedProducts = (rows || []).map((row, index) => ({
    id: `invoice-${Date.now()}-${index}`,
    productId: row.productId === '__new__' ? null : row.productId,
    productName: String(row.description || '').trim(),
    barcode: row.productId === '__new__' ? '' : (products.find(p => p.id === row.productId)?.barcode || ''),
    quantity: normalizeQuantityNumber(row.quantity),
    unitCost: Number(row.unitCost || 0),
    totalCost: normalizeCOP(row.totalCost),
    productUnit: row.unit || 'unidad',
    createNew: row.productId === '__new__',
    source: 'invoice_scan',
  }));

  setEntryData(prev => ({
    ...prev,
    supplier: String(supplier || '').trim(),
    invoiceNumber: String(invoiceNumber || '').trim(),
    registrationDate: date || prev.registrationDate,
    products: importedProducts,
  }));
  setInvoiceFiles(Array.isArray(files) ? files : []);
};

const buildEntryCashFields = () => {
  const isPaid = String(entryData.paymentStatus || '').toLowerCase() === 'pagado';
  if (!isPaid) {
    return { paidFrom: 'otro', affectsCash: false, turnId: null };
  }

  if (affectsCash && selectedCashId) {
    return { paidFrom: 'caja', affectsCash: true, turnId: selectedCashId };
  }

  return { paidFrom: 'otro', affectsCash: false, turnId: null };
};

  // Caja: permitir afectar una caja abierta
  const [affectsCash, setAffectsCash] = useState(false);
  const [openCashDrawers, setOpenCashDrawers] = useState([]);
  const [selectedCashId, setSelectedCashId] = useState('');

  useEffect(() => {
    if (costMode !== 'unit') return;
    const qty = normalizeQuantityNumber(currentProductInput.quantity);
    const unit = normalizeCOP(currentProductInput.unitCost);
    const total = qty * unit;
    setCurrentProductInput(prev => ({ ...prev, totalCost: Math.round(total) }));
  }, [costMode, currentProductInput.quantity, currentProductInput.unitCost]);

useEffect(() => {
  const KEY = "valenpos:proveedores:v1";

  // Pintar inmediatamente desde cache local (no bloquea UI)
  try {
    const cached = JSON.parse(localStorage.getItem(KEY) || "[]");
    if (Array.isArray(cached) && cached.length) setProveedores(cached);
  } catch {}

  // Suscribirse a cambios (Firestore cache + red)
  const unsub = onSnapshot(collection(db, 'proveedores'), (snap) => {
    const lista = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    setProveedores(lista);
    try { localStorage.setItem(KEY, JSON.stringify(lista)); } catch {}
  });

  return () => unsub();
}, []);

// Cargar cajas abiertas para poder afectar caja si la entrada queda pagada
useEffect(() => {
  try {
    const q = query(collection(db, 'cajas'), where('estado', '==', 'abierta'));
    const unsub = onSnapshot(q, (snap) => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setOpenCashDrawers(list);
      // Preseleccionar mi caja si existe
      const meKey = (currentUser?.username || currentUser?.email || currentUser || '').toString();
      const mine = list.find(c => (c.user || '') === meKey);
      if (mine && !selectedCashId) setSelectedCashId(mine.id);
    });
    return () => unsub();
  } catch (_) { /* ignore */ }
}, [currentUser, selectedCashId]);
  useEffect(() => {
    if (editingEntry) {
const normalizedProducts = Array.isArray(editingEntry.products)
  ? editingEntry.products.map(p => ({
      ...p,
      quantity: normalizeQuantityNumber(p.quantity),
      unitCost: normalizeCOP(p.unitCost),
      totalCost: normalizeCOP(p.totalCost),
    }))
  : [];
setEntryData({
   ...editingEntry,
  products: normalizedProducts,
  registeredBy:
     typeof editingEntry.registeredBy === 'string'
      ? editingEntry.registeredBy
      : (editingEntry.registeredBy?.username ||
         editingEntry.registeredBy?.email ||
         editingEntry.registeredBy?.uid ||
        '')
 }); 
      setAffectsCash(!!editingEntry.affectsCash);
      setSelectedCashId(editingEntry.turnId || '');

    }
    
     else {
      setEntryData({
        invoiceNumber: '', supplier: '', entryType: 'compra', paymentStatus: 'pendiente',
        proofImage: '', products: [],
registeredBy:
  typeof currentUser === 'string'
    ? currentUser
      : (currentUser?.username || currentUser?.email || currentUser?.uid || ''),
        registrationDate: localYMD()
      });
      setAffectsCash(false);
      setSelectedCashId('');
    }
  }, [editingEntry, currentUser]);

// Cuando se usa "costo total", conserva el total digitado y calcula el
// unitario automáticamente (incluidos costos fraccionarios por gramo).
useEffect(() => {
  if (costMode !== 'total') return;
  const q = normalizeQuantityNumber(currentProductInput.quantity);
  const t = normalizeCOP(totalCost);
  const unit = q > 0 ? t / q : 0;
  setCurrentProductInput(prev => ({
    ...prev,
    unitCost: Number(unit.toFixed(4)),   // costo por g o por unidad
    totalCost: t,
  }));
}, [totalCost, costMode, currentProductInput.quantity]);


  const handleEntryDataChange = (e) => {
    const { name, value } = e.target;
    setEntryData(prev => ({ ...prev, [name]: value }));
  };

const handleRemoveProductFromEntry = (id) => {
  setEntryData((prev) => {
    const nuevosProductos = prev.products.filter(
      (prod) =>
        prod.productId !== id && prod.productName !== id
    );

    return {
      ...prev,
      products: nuevosProductos,
    };
  });
};

  const handleProductInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'unitCost') {
      const normalized = value === '' ? '' : normalizeCOP(value);
      setCurrentProductInput(prev => ({ ...prev, unitCost: normalized }));
      return;
    }

    if (name === 'quantity') {
      const normalized = value === '' ? '' : normalizeQuantityNumber(value);
      setCurrentProductInput(prev => ({ ...prev, quantity: normalized }));
      return;
    }

    setCurrentProductInput(prev => ({
      ...prev,
      [name]: value
    }));

 if (name === 'productName') {
 const q = value.trim().toLowerCase();
  clearTimeout(typingTimer.current);
 typingTimer.current = setTimeout(() => {
  if (q.length > 1) {
     const onlyInsumos = products
.filter(p => {
   const type = normalizedType(p);
   const isRecipe = type === 'receta';
  const isIce = !!p?.config?.isIceCream;
   const blocked = !!p?.excludeFromEntries;
  // excluir recetas, helados o marcados manualmente
   if (isRecipe || isIce || blocked) return false;
  // permitir insumo y final normales
   return (type === 'insumo' || type === 'final');
 })        .filter(p =>
         (p.name || '').toLowerCase().includes(q) ||
          (p.barcode || '').toLowerCase().includes(q)
        );
      // Deduplicar por id/barcode para evitar keys repetidas
      const seen = new Set();
      const deduped = [];
      for (const p of onlyInsumos) {
        const key = p.id || p.barcode || p.name;
        if (!key || seen.has(key)) continue;
        seen.add(key);
        deduped.push(p);
      }
      setProductSuggestions(deduped);
      setShowSuggestions(deduped.length > 0);
    } else {
       setProductSuggestions([]);
      setShowSuggestions(false);
    }
  }, 180); // 180-250ms va bien
 }  };

const handleTotalCostChange = (rawValue) => {
  if (rawValue === '' || rawValue === null || rawValue === undefined) {
    setTotalCost('');
    setCurrentProductInput(prev => ({ ...prev, totalCost: 0 }));
    return;
  }
  const normalized = normalizeCOP(rawValue);
  setTotalCost(normalized);
  setCurrentProductInput(prev => ({ ...prev, totalCost: normalized }));
};

const handleSelectProduct = (product) => {
  setCurrentProductInput(prev => ({
    ...prev,
    productId: product.id,
    productName: product.name,
    barcode: product.barcode,
    unitCost: product.costPrice ?? '',
    productUnit: product.unit || 'unidad',   // 👈 agrega esto
  }));
  setShowSuggestions(false);
};

const handleAddProductToEntry = () => {
   const prodSel = products.find(p => p.id === currentProductInput.productId);
const isScannedNewProduct = !!currentProductInput.createNew && !currentProductInput.productId;
if (!prodSel && !isScannedNewProduct) {
  alert('Selecciona un producto válido de la lista.');
   return;
 }
const t = String(prodSel?.type || 'insumo').toLowerCase();
if (prodSel && (t === 'receta' || prodSel?.config?.isIceCream || prodSel?.excludeFromEntries)) {
  alert('Este producto está marcado para NO recibir ENTRADAS (receta/helado/excluido).');
  return;
 }
  const quantityNumber = normalizeQuantityNumber(currentProductInput.quantity);
  const unitCostNumber = normalizeCOP(currentProductInput.unitCost);
  const totalCostNumber = normalizeCOP(
    currentProductInput.totalCost !== '' && currentProductInput.totalCost !== undefined
      ? currentProductInput.totalCost
      : quantityNumber * unitCostNumber
  );
  if (!currentProductInput.productId && !isScannedNewProduct) {
    alert('Selecciona un producto de la lista (haz clic en una sugerencia).');
    return;
  }
  if (!currentProductInput.productName || quantityNumber <= 0) {
    alert('Completa los datos del producto.');
    return;
  }
  if (currentProductInput.unitCost === '' || unitCostNumber < 0) {
    alert('Ingresa un costo válido.');
    return;
  }


  let barcodeGenerado = currentProductInput.barcode;

  // Si no se seleccionó de sugerencia y no hay código, generamos uno aleatorio
  if (!barcodeGenerado || barcodeGenerado.trim() === '') {
    barcodeGenerado = `BAR-${Date.now()}`;
  }

const nuevoProducto = {
  ...currentProductInput,
  quantity: quantityNumber,
  unitCost: unitCostNumber,
  totalCost: totalCostNumber,
  barcode: barcodeGenerado,
  id: editingProductId || Date.now(),
  productId: currentProductInput.productId || null  // 👈 aseguramos campo productId
};

  if (editingProductId) {
    setEntryData(prev => ({
      ...prev,
      products: prev.products.map(p =>
        p.id === editingProductId ? nuevoProducto : p
      )
    }));
    setEditingProductId(null);
  } else {
    setEntryData(prev => ({
      ...prev,
      products: [...prev.products, nuevoProducto]
    }));
  }

setCurrentProductInput({
  productId: '',
  productName: '',
  barcode: '',
  quantity: 1,
  unitCost: '',
  totalCost: 0,
  productUnit: 'unidad',
  createNew: false
});
setTotalCost('');


};



const handleProofImageUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  try {
    const data = await uploadImage(file, 'incoming');

    setEntryData(prev => ({
      ...prev,
      proofImage: data.secure_url,
      proofImageId: data.public_id || ''
    }));

  } catch (error) {
    console.error("Error al subir imagen:", error);
    alert("❌ Error al subir la imagen");
  }
};

const uploadInvoiceProofFile = async (file) => {
  const data = await uploadImage(file, 'incoming');
  if (!data?.secure_url) throw new Error('No se pudo subir la imagen de la factura.');
  return { url: data.secure_url, id: data.public_id || '' };
};

  const handleAddIncoming = async (e) => {
  e.preventDefault();
  if (entryData.products.length === 0) {
    toast.warn('Debes agregar al menos un producto.', { autoClose: 2200 });
    return;
  }

  const normalizeProductForSave = (p) => {
    const quantity = normalizeQuantityNumber(p.quantity);
    const unitCost = normalizeCOP(p.unitCost);
    const totalCost = normalizeCOP(p.totalCost) || Math.round(quantity * unitCost);
    return stripUndefinedDeep({
      ...p,
      productId: p.productId || null,
      productUnit: p.productUnit || 'unidad',
      createNew: !!p.createNew,
      quantity,
      unitCost,
      totalCost,
    });
  };

  setLoading(true);
  try {
    const uploadedProofs = invoiceFiles.length
      ? await Promise.all(invoiceFiles.map(uploadInvoiceProofFile))
      : [];
    const entryForSave = uploadedProofs.length ? {
      ...entryData,
      proofImage: uploadedProofs[0].url,
      proofImageId: uploadedProofs[0].id,
      proofImages: uploadedProofs.map(item => item.url),
      proofImageIds: uploadedProofs.map(item => item.id),
      analyzedFromInvoice: true,
    } : entryData;

    const catalogByName = new Map(
      (products || [])
        .filter(product => {
          const type = String(product?.type || 'final').toLowerCase();
          return !product?.deleted && type !== 'receta' && !product?.config?.isIceCream && !product?.excludeFromEntries;
        })
        .map(product => [normalizeProductName(product.name), product])
    );
    const pendingNewProducts = [];
    const productsNormalizedForState = (entryForSave.products || []).map((rawProduct, index) => {
      const normalized = normalizeProductForSave(rawProduct);
      if (!normalized.createNew || normalized.productId) return normalized;

      const existing = catalogByName.get(normalizeProductName(normalized.productName));
      if (existing?.id) {
        return {
          ...normalized,
          productId: existing.id,
          productName: existing.name,
          barcode: existing.barcode || '',
          productUnit: existing.unit || normalized.productUnit || 'unidad',
          createNew: false,
        };
      }

      const productRef = doc(collection(db, 'productos'));
      const productDoc = {
        name: String(normalized.productName || '').trim().toUpperCase(),
        barcode: `AUTO-${productRef.id.slice(0, 12).toUpperCase()}`,
        image: '',
        price: 0,
        costPrice: Number(normalized.unitCost || 0),
        stock: 0,
        category: 'Insumos',
        type: 'insumo',
        unit: normalized.productUnit || 'unidad',
        config: null,
        excludeFromEntries: false,
        registeredBy: safeRegisteredBy(),
        registrationDate: entryForSave.registrationDate || localYMD(),
        source: 'invoice_scan',
      };
      pendingNewProducts.push({ ref: productRef, data: productDoc, index });
      catalogByName.set(normalizeProductName(productDoc.name), { id: productRef.id, ...productDoc });
      return {
        ...normalized,
        productId: productRef.id,
        productName: productDoc.name,
        barcode: productDoc.barcode,
        createNew: false,
      };
    });

    if (editingEntry && pendingNewProducts.length) {
      throw new Error('Guarda los productos nuevos desde una entrada nueva.');
    }

    const total = productsNormalizedForState.reduce((sum, p) => sum + p.totalCost, 0);
    const productsNormalized = productsNormalizedForState;
    const entryTotal = total;

    const entryPayload = stripUndefinedDeep({
      ...entryForSave,
      ...buildEntryCashFields(),
      products: productsNormalized,
      totalEntryCost: entryTotal,
    });

    const idempotencyKey = saveOperationKeyRef.current || createIncomingOperationKey();
    saveOperationKeyRef.current = idempotencyKey;

    const result = editingEntry
      ? await updateIncomingEntryApi({
          entryId: editingEntry.id,
          entry: entryPayload,
          idempotencyKey,
        })
      : await createIncomingEntryApi({
          entry: entryPayload,
          newProducts: pendingNewProducts.map(({ ref, data }) => ({ id: ref.id, ...data })),
          idempotencyKey,
        });

    // Si el servidor respondió, la transacción quedó confirmada y ya podemos
    // abandonar la clave de reintento. Si la red falla, se conserva para que
    // el siguiente intento no duplique la entrada.
    saveOperationKeyRef.current = '';

    const savedEntry = result?.entry || {
      ...entryPayload,
      id: editingEntry?.id || result?.entryId,
      date: entryPayload.registrationDate,
    };

    setIncomingItems(prev => {
      if (editingEntry) {
        return prev.map(item => item.id === editingEntry.id ? { ...item, ...savedEntry, id: editingEntry.id } : item);
      }
      return [{ ...savedEntry, id: result.entryId }, ...prev];
    });

    if (typeof setProducts === 'function' && Array.isArray(result?.productUpdates)) {
      setProducts(previous => {
        const updates = new Map(result.productUpdates.map(item => [item.id, item]));
        const merged = previous.map(product => {
          const update = updates.get(product.id);
          if (!update) return product;
          const { created, ...safeUpdate } = update;
          return { ...product, ...safeUpdate };
        });
        result.productUpdates.forEach(update => {
          if (!update?.created || merged.some(product => product.id === update.id)) return;
          const { created, ...safeUpdate } = update;
          merged.push(safeUpdate);
        });
        return merged;
      });
    }

    setEditingEntry(null);
    setInvoiceFiles([]);
    setShowForm(false);
  } catch (error) {
    alert(error?.message || 'Error al guardar la entrada');
    console.error('¡O Error al guardar:', error.message, error);
  } finally {
    setLoading(false);
  }
};


  return (
    <form onSubmit={handleAddIncoming} className="mx-auto max-w-5xl rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm sm:p-8">
      <h2 className="mb-6 text-center text-2xl font-black text-slate-900 sm:text-3xl">
        {editingEntry ? 'Editar Entrada' : 'Registrar Nueva Entrada'}
      </h2>

      {!editingEntry && (
        <InvoiceScanner products={products} onApply={handleInvoiceApply} />
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium mb-1">N° Factura/Documento</label>
<input
  type="text"
  name="invoiceNumber"
  value={entryData.invoiceNumber}
  onChange={handleEntryDataChange}
  className="w-full px-4 py-2 border border-gray-300 rounded"
/>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Proveedor</label>
          <select
            name="supplier"
            value={entryData.supplier}
            onChange={handleEntryDataChange}
            className="w-full border border-gray-300 p-2 rounded"
          >
            <option value="">Selecciona un proveedor</option>
            {entryData.supplier && !proveedores.some(p => p.nombre === entryData.supplier) && (
              <option value={entryData.supplier}>{entryData.supplier} (detectado)</option>
            )}
            {proveedores.map(p => (
              <option key={p.id} value={p.nombre}>{p.nombre}</option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Tipo de Entrada</label>
          <select
            name="entryType"
            value={entryData.entryType}
            onChange={handleEntryDataChange}
            className="w-full border border-gray-300 p-2 rounded"
          >
            <option value="compra">Compra</option>
            <option value="ajuste">Ajuste</option>
            <option value="donación">Donación</option>
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium mb-1">Estado de Pago</label>
          <select
            name="paymentStatus"
            value={entryData.paymentStatus}
            onChange={handleEntryDataChange}
            className="w-full border border-gray-300 p-2 rounded"
          >
            <option value="pendiente">Pendiente</option>
            <option value="pagado">Pagado</option>
          </select>
        </div>

      </div>

      {/* Opciones de caja cuando queda pagado */}
      {String(entryData.paymentStatus || '').toLowerCase() === 'pagado' && (
        <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="flex items-center gap-2">
            <input
              id="affectsCash"
              type="checkbox"
              className="h-4 w-4"
              checked={affectsCash}
              onChange={(e) => setAffectsCash(e.target.checked)}
            />
            <label htmlFor="affectsCash" className="text-sm text-gray-700">
              Afectar caja (disminuye efectivo)
            </label>
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium mb-1">Caja a afectar</label>
            <select
              disabled={!affectsCash}
              value={selectedCashId}
              onChange={(e) => setSelectedCashId(e.target.value)}
              className="w-full border border-gray-300 p-2 rounded disabled:bg-gray-100"
            >
              <option value="">Selecciona una caja abierta…</option>
              {openCashDrawers.map(c => (
                <option key={c.id} value={c.id}>
                  {`${c.user || 'usuario'} — ${c.fecha || ''} ${c.hora || ''}`}
                </option>
              ))}
            </select>
            {!affectsCash && (
              <p className="text-xs text-gray-500 mt-1">Si no marcas esta opción, la entrada no afectará tu cierre.</p>
            )}
          </div>
        </div>
      )}

      {/* Aquí puedes continuar agregando los campos de productos, sugerencias, botones, etc., usando el mismo estilo */}
<div className="mt-6">
  <label className="block text-sm font-medium text-gray-700">Imagen del comprobante</label>
  <input
    type="file"
    accept="image/jpeg,image/png,image/webp"
    onChange={handleProofImageUpload}
    className="mt-1 block w-full rounded-xl border border-gray-300 bg-white px-3 py-2 text-sm"
  />
  {entryData.proofImage && (
  <img
    id="proof-preview"
    src={entryData.proofImage}
    alt="Comprobante"
    className="mt-4 w-48 rounded shadow border"
  />
)}

</div>

      <div className="mt-6 flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
        <button
          type="button"
          onClick={() => setShowForm(false)}
          className="rounded-2xl bg-gray-200 px-4 py-3 text-sm font-semibold text-gray-800 transition hover:bg-gray-300"
        >
          Cancelar
        </button>
        <button
          type="submit"
          className="rounded-2xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Guardando..." : editingEntry ? "Guardar Cambios" : "Registrar Entrada"}
        </button>
      </div>
      {/* Sección de productos de la entrada */}
<h3 className="text-xl font-bold text-gray-800 mt-6">Productos de la Entrada</h3>

<div className="mt-4 grid grid-cols-1 gap-4 md:grid-cols-3">
  {/* Nombre del producto (autocompletar) */}
{/* Nombre del producto (autocompletar) */}
<div className="md:col-span-2 relative">
  <label className="block text-sm font-medium text-gray-700">Producto</label>
  <input
    type="text"
    name="productName"
    value={currentProductInput.productName}
    onChange={handleProductInputChange}
    className="w-full rounded-2xl border border-gray-300 px-4 py-3 focus:border-blue-500 focus:ring-2 focus:ring-blue-500 transition"
    autoComplete="off"
    placeholder="Escribe al menos 2 letras…"
  />

  {/* ✅ Toggle para casos especiales */}
  <label className="flex items-center gap-2 mt-2 text-xs text-gray-600">
    <input
      type="checkbox"
      checked={mostrarTodos}
      onChange={(e) => setMostrarTodos(e.target.checked)}
    />
    Mostrar también productos para vender
  </label>

  {showSuggestions && productSuggestions.length > 0 && (
    <div className="absolute z-10 mt-1 w-full bg-white border border-gray-300 rounded shadow max-h-48 overflow-auto">
      {productSuggestions.map(product => (
        <div
          key={product.id || product.barcode || `product-${product.name}-${Math.random()}`}
          className="px-4 py-2 hover:bg-blue-50 cursor-pointer flex items-center justify-between gap-3"
          onClick={() => handleSelectProduct(product)}
        >
          <div>
            <div className="font-medium">{product.name}</div>
            <div className="text-xs text-gray-500">
              Código: {product.barcode} · Unidad: {product.unit || 'unidad'}
            </div>
          </div>

          {/* ✅ Badge para diferenciar */}
          <span
            className={`text-[10px] px-2 py-0.5 rounded-full ${
              (product?.type || 'final') === 'insumo'
                ? 'bg-green-100 text-green-700'
                : 'bg-gray-100 text-gray-600'
            }`}
          >
            {(product?.type || 'final') === 'insumo' ? 'INSUMO' : 'PARA VENDER'}
          </span>
        </div>
      ))}
    </div>
  )}
</div>

  {/* Código */}
  <div>
    <label className="block text-sm font-medium text-gray-700">Código</label>
    <input
      type="text"
      name="barcode"
      value={currentProductInput.barcode}
      readOnly
    className="w-full rounded-2xl border border-gray-300 bg-gray-100 px-4 py-3"
    />
  </div>

  {/* Cantidad */}
<div>
{/* Cantidad con unidad dinámica */}
<label className="block text-sm font-medium mb-1">
  Cantidad {currentProductInput.productUnit ? `(${currentProductInput.productUnit})` : ''}
</label>
<input
  type="number"
  min="0"
  step={currentProductInput.productUnit === 'g' ? '1' : '1'}
  name="quantity"
  value={currentProductInput.quantity}
  onChange={handleProductInputChange}
  className="w-full rounded-2xl border px-3 py-3"
/>
{currentProductInput.productUnit === 'g' && (
  <p className="text-xs text-gray-500 mt-1">Ej: 5000 = 5 kg</p>
)}

<label className="inline-flex items-center gap-2 mb-2">
  <input
    type="checkbox"
    checked={costMode === 'total'}
    onChange={e => setCostMode(e.target.checked ? 'total' : 'unit')}
  />
  <span>Ingresar por costo total</span>
</label>

{/* Costo */}
{costMode === 'unit' ? (
  <>
    <label className="block text-sm font-medium mb-1 mt-3">
      Costo unitario por {currentProductInput.productUnit || 'unidad'}
    </label>
    <input
      type="text"
      inputMode="numeric"
      name="unitCost"
      value={currentProductInput.unitCost}
      onChange={handleProductInputChange}
      className="w-full rounded-2xl border px-3 py-3"
/>
  </>
) : (
  <>
    <label className="block text-sm font-medium mb-1 mt-3">Costo total del producto</label>
    <input
      type="text"
      inputMode="numeric"
      value={totalCost}
      onChange={e => handleTotalCostChange(e.target.value)}
      className="w-full rounded-2xl border px-3 py-3"
/>
  </>
)}
</div>

  {/* Costo total */}
  <div>
    <label className="block text-sm font-medium text-gray-700">Costo Total Producto</label>
    <input
      type="text"
      value={`$${formatCurrency(currentProductInput.totalCost)}`}
      readOnly
      className="w-full rounded-2xl border border-gray-300 bg-gray-100 px-4 py-3"
    />
  </div>

  {/* Botón para agregar producto */}
  <div className="md:col-span-3 flex justify-end">
<button
  type="button"
  onClick={handleAddProductToEntry}
  className="w-full rounded-2xl bg-blue-600 px-4 py-3 text-sm font-semibold text-white transition hover:bg-blue-700 sm:w-auto"
>
  {editingProductId ? "Guardar Cambios" : "Agregar Producto a Entrada"}
</button>
  </div>
</div>
{entryData.products.length > 0 && (
  <div className="mt-6">
    <h4 className="text-md font-semibold text-gray-700 mb-2">Productos añadidos:</h4>
<div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
  {entryData.products.map(p => (
    <div key={p.id} className="bg-white border border-gray-300 rounded-lg shadow p-4 flex justify-between items-start">
      <div>
        <h4 className="font-bold text-gray-800">{p.productName}</h4>
        {p.createNew && (
          <span className="mb-1 inline-flex rounded-full bg-sky-100 px-2 py-0.5 text-[10px] font-bold uppercase text-sky-700">Se creará al registrar</span>
        )}
        <p className="text-sm text-gray-600">
          Cantidad: <span className="font-medium">{p.quantity}</span><br />
          Costo unitario: <span className="font-medium">${formatCurrency(p.unitCost)}</span><br />
          Total: <span className="font-semibold text-blue-800">${formatCurrency(p.totalCost)}</span>
        </p>
      </div>
      <div className="flex flex-col gap-2 text-sm text-right">
        <button
          type="button"
          onClick={() => {
            setEditingProductId(p.id);
            setCurrentProductInput({
              productId: p.productId || null,
              productName: p.productName || '',
              barcode: p.barcode || '',
              quantity: p.quantity,
              unitCost: p.unitCost,
              totalCost: p.totalCost,
              productUnit: p.productUnit || 'unidad',
              createNew: !!p.createNew
            });
          }}
          className="text-blue-600 hover:underline"
        >
          Editar
        </button>
<button
  type="button"
  onClick={() => handleRemoveProductFromEntry(p.productId || p.id)}
  className="text-red-600 hover:underline"
>
  Eliminar
</button>
      </div>
    </div>
  ))}
</div>
  <div className="mt-6 flex justify-end">
  <div className="bg-blue-100 text-blue-800 font-semibold px-6 py-3 rounded-xl shadow text-lg">
    Total Entrada: ${formatCurrency(entryData.products.reduce((sum, p) => sum + normalizeCOP(p.totalCost), 0))}
  </div>
</div>
  </div>
)}

    </form>
  );
};

export default IncomingForm;
